<template>
  <div>
    <a href="https://tucsonpathways.org"><div id="logo">Tp</div></a>
    <div id="backgroundart"></div>
    <div id="registerBody">
      <div class="banner">register</div>
      <form @submit.prevent="pressed">
        <br />
        <div class="blankLines">
          <input type="email" placeholder="email@address.com" v-model="email" />
        </div>
        <div class="blankLines">
          <input
            id="passUniqueID"
            type="password"
            placeholder="**********"
            v-model="password"
          />
        </div>
        <div class="togglePassword">
          <input type="checkbox" @click="togglePasswordVisibility" />
          <p>show password</p>
        </div>
        <br />
        <button type="submit" class="btn btn-warning">
          Make It So!
        </button>
        <!-- <p class="tiny">
        <br />
        Our goal is to provide
        <span style="font-weight:bold">safe & scenic bicycle navigation</span>
        through our pathways web-app<br />
        along with highlighting Tucson's local businesses + community events +
        volunteer opportunities
      </p> -->
        <p>
          Currently supporting
          <span style="font-weight:bold"
            >Tucson, South Tucson, & Oro Valley Metros</span
          >.
          <br />
          Learn how you can
          <router-link to="/donate">
            <span style="font-weight:bold; color: blue;">
              help our organization</span
            >
          </router-link>
          here.<br /><br />
        </p>
      </form>
      <div class="error" v-if="error">{{ error.message }}</div>
      <span
        >Already a Member? Sign in
        <router-link to="/login">Here</router-link></span
      >
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";

export default {
  data() {
    return {
      email: "",
      password: "",
      error: ""
    };
  },
  methods: {
    togglePasswordVisibility() {
      var x = document.getElementById("passUniqueID");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    async pressed() {
      try {
        const user = await firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password);
        console.log(user);
        this.$router.replace({ name: "Map" }); //name: "Static"
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#logo {
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0px;
  position: absolute;
  z-index: 3;
  max-width: 80px;
  max-height: 80px;
  left: 10px;
  background: #363636;
  width: 14vw;
  height: 14vw;
  font-size: 2.5em;
  line-height: 2.5em;
  color: white;
  text-align: center;
  font-family: auto;
  // box-shadow: 3px 3px 6px grey;
}

#backgroundart {
  z-index: -1;
  position: fixed;
  top: 0px;
  bottom: 0px;
  width: 100%;
  background-image: url("../assets/Background2.png");
  background-size: cover;
  // background-repeat: no-repeat;
  // background-attachment: fixed;
}

.togglePassword {
  > p {
    display: inline-block;
    margin-left: 10px;
    font-size: 0.75em;
  }
}

#registerBody {
  form {
    background: white;
  }

  .tiny {
    font-size: 0.75em;
    margin: 5px;
  }
  .banner {
    color: #363636;
    text-shadow: 3px 3px 3px rgba(0, 0, 0, 0.5);
    font-size: 4em;
    margin: 5vh;
  }

  .btn.btn-warning {
    color: white;
    background-color: black;
    border: none;
    outline: none;
    border-radius: 0px;
    margin-bottom: 15px;
    font-style: italic;
    width: 150px;
  }

  font-family: Georgia, "Times New Roman", Times, serif;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 44px;
  text-align: center;

  @media (max-width: 812px) {
    > form {
      width: 80vw;
      margin: 3vh auto 5vh auto;
    }
  }

  @media (min-width: 812px) {
    > form {
      width: 50vw;
      margin: 5vh auto 5vh auto;
    }
  }

  > form {
    padding: 5vh 5vw;
    border: solid 1px grey;
    box-shadow: 6px 6px 6px rgba(0, 0, 0, 0.5);

    > p {
      font-size: 12px;
    }

    > .blankLines {
      margin: 20px;

      > input {
        text-align: center;
        border-top: none;
        border-right: none;
        border-left: none;
        border-bottom: solid 1px grey;
        width: 100%;
        outline: none;

        &:focus::-webkit-input-placeholder {
          color: transparent; //this removes the placeholder text "Your Email", when the input box is focused
        }

        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
      }
    }
  }

  > * {
    margin: 10px;
  }
}
</style>
